import { IS_HSL_SERVICE_ENVIRONMENT } from 'Util/constants'

// Because of the differences between Waltti and HSL product inheritance logic,
// we need to use different keys for filtering products in tariffs.
const IN_TARIFF_PARENT_PRODUCTS_FILTER_KEY = 'in_tariff_parent_products'
const IN_TARIFF_FILTER_KEY = 'in_tariff'
const PRODUCT_IDS_FIELD = 'product_ids'
const PARENT_PRODUCT_IDS_FIELD = 'parent_product_ids'

export function getProductsInTariffParamKey(inCatalog?: string) {
  if (inCatalog) {
    // When filtering products in a catalog, always use the IN_TARIFF_FILTER_KEY
    return IN_TARIFF_FILTER_KEY
  }
  return IS_HSL_SERVICE_ENVIRONMENT ? IN_TARIFF_FILTER_KEY : IN_TARIFF_PARENT_PRODUCTS_FILTER_KEY
}

export function getTariffProductIdsField() {
  return IS_HSL_SERVICE_ENVIRONMENT ? PRODUCT_IDS_FIELD : PARENT_PRODUCT_IDS_FIELD
}
